
export const dentistsData = [
  {
    id: 1,
    name: 'Dr. Emily Harrison',
    credentials: 'DDS, FAGD',
    specialization: 'General & Cosmetic Dentistry',
    experience: 15,
    bio: 'Dr. Harrison is passionate about creating beautiful, healthy smiles. With over 15 years of experience, she specializes in cosmetic dentistry and comprehensive oral care.',
    image: 'https://public.readdy.ai/ai/img_res/2e1a4036f0745e8450130bd5f3984272.jpg',
  },
  {
    id: 2,
    name: 'Dr. James Mitchell',
    credentials: 'DMD, MS',
    specialization: 'Orthodontics',
    experience: 12,
    bio: 'Dr. Mitchell brings expertise in orthodontics and a gentle approach to patient care. He is dedicated to helping patients achieve their ideal smile through advanced orthodontic treatments.',
    image: 'https://readdy.ai/api/search-image?query=Orthodontic%20tools%20and%20clear%20aligners%20displayed%20on%20natural%20marble%20surface%20with%20small%20potted%20succulent%20soft%20natural%20lighting%20cream%20background%20professional%20dental%20product%20photography%20minimalist%20aesthetic&width=400&height=500&seq=dentist-equipment-2&orientation=portrait',
  },
  {
    id: 3,
    name: 'Dr. Sarah Patel',
    credentials: 'DDS',
    specialization: 'Pediatric Dentistry',
    experience: 10,
    bio: 'Dr. Patel specializes in pediatric dentistry and loves working with children. Her gentle, patient approach helps young patients feel comfortable and develop positive dental habits.',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20child-friendly%20dental%20tools%20and%20toothbrushes%20arranged%20on%20light%20wood%20surface%20with%20small%20plant%20soft%20warm%20lighting%20playful%20yet%20professional%20pediatric%20dental%20photography%20cream%20background&width=400&height=500&seq=dentist-equipment-3&orientation=portrait',
  },
  {
    id: 4,
    name: 'Dr. Robert Chen',
    credentials: 'DDS, FICOI',
    specialization: 'Implant & Restorative',
    experience: 18,
    bio: 'Dr. Chen is an expert in dental implants and restorative dentistry. His precision and attention to detail ensure exceptional results for complex dental procedures.',
    image: 'https://readdy.ai/api/search-image?query=Dental%20implant%20model%20and%20precision%20instruments%20on%20clean%20white%20surface%20with%20eucalyptus%20sprig%20soft%20studio%20lighting%20professional%20medical%20equipment%20photography%20minimalist%20sage%20green%20accents&width=400&height=500&seq=dentist-equipment-4&orientation=portrait',
  },
];
